import * as React from 'react'

export const PartnerIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.8691 23.1374C36.0334 21.9468 37.5 19.6447 37.5 17C37.5 13.134 34.366 10 30.5 10C26.634 10 23.5 13.134 23.5 17C23.5 19.502 24.8126 21.6973 26.7868 22.9351C21.7196 24.3399 18 28.9856 18 34.5V40.5556C18 41.3533 18.6467 42 19.4444 42H40.5556C41.3533 42 42 41.3533 42 40.5556V34.5C42 29.2263 38.5981 24.7472 33.8691 23.1374Z"
        fill="#6FC400"
      />
      <path
        d="M21.052 19.3014C23.3889 18.1675 25 15.7719 25 13C25 9.13401 21.866 6 18 6C14.134 6 11 9.13401 11 13C11 15.8204 12.668 18.2513 15.0714 19.3598C9.85955 20.6669 6 25.3827 6 30.9999V36.5925C6 37.3698 6.63012 37.9999 7.40741 37.9999H22.5854C26.6804 37.9999 30 34.6803 30 30.5853C30 25.0941 26.1797 20.4952 21.052 19.3014Z"
        fill="#5BBBFC"
      />
      <path
        d="M20 26C18.8954 26 18 26.8954 18 28V30C19.1046 30 20 30.8954 20 32C20 33.1046 19.1046 34 18 34V38H22C22 39.1046 22.8954 40 24 40C25.1046 40 26 39.1046 26 38H28C29.1046 38 30 37.1046 30 36V34C31.1046 34 32 33.1046 32 32C32 30.8954 31.1046 30 30 30V28C30 26.8954 29.1046 26 28 26H20Z"
        fill="#FAF8F5"
      />
    </svg>
  )
})

PartnerIcon.displayName = 'PartnerIcon'
